import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = {
  key: 2,
  class: "lightbox__count"
}

import { ref, watch, onBeforeUnmount } from "vue";
import { Icon } from "@iconify/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Lightbox',
  props: {
    show: { type: Boolean },
    images: {},
    startIndex: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const index = ref(props.startIndex || 0);

watch(
  () => [props.show, props.startIndex],
  () => {
    if (props.show) index.value = props.startIndex || 0;
  }
);

const prev = () => {
  index.value = (index.value - 1 + props.images.length) % props.images.length;
};
const next = () => {
  index.value = (index.value + 1) % props.images.length;
};

const onKey = (e: KeyboardEvent) => {
  if (e.key === "Escape") emit("close");
  if (e.key === "ArrowLeft") prev();
  if (e.key === "ArrowRight") next();
};

watch(
  () => props.show,
  (open) => {
    if (open) document.addEventListener("keydown", onKey);
    else document.removeEventListener("keydown", onKey);
  },
  { immediate: true }
);

onBeforeUnmount(() => document.removeEventListener("keydown", onKey));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "lightbox",
          role: "dialog",
          "aria-modal": "true",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('close')), ["self"]))
        }, [
          _createElementVNode("button", {
            class: "lightbox__close",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
            "aria-label": "Close"
          }, [
            _createVNode(_unref(Icon), { icon: "mdi:close" })
          ]),
          (__props.images.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "lightbox__nav lightbox__nav--prev",
                type: "button",
                onClick: prev,
                "aria-label": "Previous image"
              }, [
                _createVNode(_unref(Icon), { icon: "mdi:chevron-left" })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("img", {
            src: __props.images[index.value],
            alt: `Image ${index.value + 1} of ${__props.images.length}`
          }, null, 8, _hoisted_1),
          (__props.images.length > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "lightbox__nav lightbox__nav--next",
                type: "button",
                onClick: next,
                "aria-label": "Next image"
              }, [
                _createVNode(_unref(Icon), { icon: "mdi:chevron-right" })
              ]))
            : _createCommentVNode("", true),
          (__props.images.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(index.value + 1) + " / " + _toDisplayString(__props.images.length), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})